import heicConvert from "heic-convert/browser";
import { IConverter } from "./IConverter";

const HvecToJpeg = (): IConverter => {
  const convert = async (file: File): Promise<File> => {
    const outputBuffer = await heicConvert({
      buffer: await file.arrayBuffer(),
      format: "JPEG",
    });

    return new File([outputBuffer], `${file.name.split(".")[0]}.jpeg`, {
      type: "image/jpeg",
      lastModified: Date.now(),
    });
  };

  return { convert };
};

export default HvecToJpeg;
